import React from "react";
import { Row, Col } from "react-bootstrap";
import { array, object, number } from "prop-types";
import AverageScoreScale from "components/DynamicScoreReportScales/AverageScoreScale";

const CTRSE = (props) => {
  // ---------------------------- Prop Deconstruction ---------------------------
  const {
    candidateInfo,
    SelectedScoreRangeSection,
    testId,
    testScores,
  } = props;

  // ---------------------------- Results Details ---------------------------
  const getResultsDetails = () => {
    const firstName = candidateInfo && candidateInfo.get("testTakerFirstName");
    const percentile =
      testScores && testScores.get("percentile") && testScores.get("percentile") !== null
        ? testScores.get("percentile")
        : 0;
    let dynamicResponse;
    if (percentile >= 90) {
      dynamicResponse = `be much more effective than most`;
    } else if (percentile >= 75) {
      dynamicResponse = `be more effective than most`;
    } else if (percentile >= 26) {
      dynamicResponse = `be as effective as most`;
    } else if (percentile >= 11) {
      dynamicResponse = `be less effective than most`;
    } else {
      dynamicResponse = `be much less effective than most`;
    }

    return (
      <Row>
        <Col>
          <h3 className="reportHeader mt-4">Results Details</h3>
          <div className="px-3 pb-3">
            <AverageScoreScale score={percentile} testId={testId} />
          </div>
          <p>
            {`${firstName}'s overall score was higher than ${percentile} percent of the general population, which indicates that they are likely to ${dynamicResponse} in interpreting and applying information appropriately to complete tasks.`}
          </p>
          {SelectedScoreRangeSection ? (
            <div className="mx-3">
              <hr className="divider" />
              {SelectedScoreRangeSection}
            </div>
          ) : null}
          {SelectedScoreRangeSection ? (
            <div className="my-4">
              <hr className="divider" />
            </div>
          ) : null}
        </Col>
      </Row>
    );
  };



  return (
    <div>
      {getResultsDetails()}
    </div>
  );
};

CTRSE.propTypes = {
  SelectedScoreRangeSection: object,
  SubcategoryScoreColumns: array,
  reportText: object,
  candidateInfo: object,
  testId: number,
  testScores: object,
};

export default CTRSE;